import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelfEmployedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.67285 9.00195C10.5446 9.0962 11.4105 9.26287 12.2607 9.50488C13.2897 9.79778 13.9998 10.7378 14 11.8076V13.0049C14 13.5544 13.5544 14 13.0049 14H2.99512C2.44562 14 2 13.5544 2 13.0049V11.8076C2.00016 10.7378 2.71031 9.79778 3.73926 9.50488C4.5892 9.26296 5.45475 9.09622 6.32617 9.00195L7.66504 9.6709C7.87596 9.77619 8.12405 9.7762 8.33496 9.6709L9.67285 9.00195ZM10.5 10.5C10.0858 10.5 9.75003 10.8358 9.75 11.25C9.75003 11.6642 10.0858 12 10.5 12H11.5C11.9142 12 12.25 11.6642 12.25 11.25C12.25 10.8358 11.9142 10.5 11.5 10.5H10.5ZM8 2C9.65685 2 11 3.34315 11 5C11 6.65685 9.65685 8 8 8C6.34315 8 5 6.65685 5 5C5 3.34315 6.34315 2 8 2Z",
		fill: "currentColor",
		stroke: "none"
	})
});
export default SvgSelfEmployedIcon;
